import ClickEvent = JQuery.ClickEvent;

interface CalculationResponse {
  total: {
    discountApplied: boolean;
    amountSubTotal: string; // sub-total cart
    amountTotal: string; // total cart
    amountDiscount: string; // discount amount
    appliedCode: string; // applied discount code
    errorMessage?: string|string[]; // only set if discountApplied = false
  };
}

declare const ajax_link: string;
declare const ajax_nonce: string;

/**
 * The coupon validator in the ext checkout
 */
export class FormValidateCoupon {

  /**
     * The toggle to show the discount form.
     */
  public $toggleVoucherBtn: JQuery<HTMLDivElement>;

  /**
     * Submit the discount code.
     */
  public $validateCouponBtn: JQuery<HTMLButtonElement>;

  /**
     * The input field.
     */
  public $couponInputField: JQuery<HTMLInputElement>;

  /**
     * The feedback notice after submitting the coupon code.
     */
  public $couponFeedbackContainer: JQuery<HTMLDivElement>;

  /**
     * The container which shows the discount calculation.
     */
  public $cartDiscount: JQuery<HTMLDivElement>;

  /**
     * The cart discount container.
     */
  public $discountAmount: JQuery<HTMLDivElement>;

  /**
     * The cart total container.
     */
  public $totalAmount: JQuery<HTMLDivElement>;

  /**
   * The progress navbar
   */
  private $progressNav: JQuery<HTMLButtonElement>;

  /**
   * The next button
   */
  private $step: JQuery<HTMLButtonElement>;

  constructor() {
    this.$validateCouponBtn = $('#validateCoupon');
    this.$couponInputField = $('#coupon_code');
    this.$couponFeedbackContainer = $('#coupon-feedback .feedback');
    this.$cartDiscount = $('.checkout-list__discount');
    this.$discountAmount = $('#discount-amount');
    this.$totalAmount = $('#total-amount');
    this.$toggleVoucherBtn = $('.js-toggle-voucher');

    this.$step = $('.js-checkout-step');
    this.$progressNav = $('.checkout__progress-steps');

    // bind events
    this.$validateCouponBtn.on('click', (e: ClickEvent) => this.validateCoupon(e));
    this.$toggleVoucherBtn.on('click', (e: ClickEvent) => this.toggleVoucher(e));
    this.$step.on('click', (e: ClickEvent) => this.hideError());
    this.$progressNav.on('click', (e: ClickEvent) => this.hideError());
  }

  /**
     * Open the voucher input fields
     * @param e
     */
  public toggleVoucher(e: ClickEvent): void {
    e.preventDefault(); // prevent user from jumping to top
    $(e.currentTarget).hide();
    $('.js-voucher-toggle').slideToggle();
  }

  /**
     * make a call to skoleo to validate the coupon code
     * @param e
     */
  public validateCoupon(e: ClickEvent): void {
    const orderType: string = $(e.currentTarget).data('ordertype');
    const couponValue: string = this.$couponInputField.val() as string;

    if (!couponValue || couponValue.length === 0) {
      this.$couponFeedbackContainer
        .removeClass('error')
        .html('')
        .hide();
      return;
    }

    this.$validateCouponBtn.attr('disabled', 'disabled');
    this.$couponFeedbackContainer.hide();

    $(e.currentTarget).append(' <i class="fa fa-circle-o-notch fa-spin"></i>');

    $.ajax({
      url: ajax_link,
      method: 'post',
      data: {
        action: 'lyceo',
        controller: 'Coupon',
        nonce: ajax_nonce,
        method: 'validateCouponCode',
        cartSession: orderType === 'school' ? 'InSchool' : 'ReservationEXT',
        couponCode: couponValue,
      },
      // backend always returns 200.
      success: (response) => this.displayDiscount(response, couponValue),
    });
  }

  public hideError(): void {
    this.$couponFeedbackContainer
      .removeClass('error')
      .html('')
      .hide();
  }

  public displayDiscount(response: CalculationResponse, couponCode: string): void {
    const { total } = response;

    this.$validateCouponBtn.removeAttr('disabled');
    this.$validateCouponBtn.find('i').remove();
    $('.spinner-coupon .fa').remove();

    if (!total.discountApplied && total.errorMessage) {

      const error: string = typeof total.errorMessage === 'string'
        ? total.errorMessage
        : total.errorMessage[0];

      this.$couponFeedbackContainer
        .removeClass('success')
        .addClass('error')
        .html(error)
        .show();
    }

    if (total.discountApplied) {
      $.ajax({
        url: ajax_link,
        method: 'post',
        data: {
          action: 'lyceo',
          controller: 'Coupon',
          nonce: ajax_nonce,
          method: 'saveCouponCode',
          couponCode: couponCode,
        },
        success: () => window.location.reload(),
      });
      this.$cartDiscount.slideDown(200);

      this.$couponFeedbackContainer
        .removeClass('error')
        .addClass('success')
        .html('De kortingscode is toegepast,<br/>'
                    + 'uw korting: <b>&euro;' + total.amountDiscount + '</b>')
        .show();
    }
  }

}

